import * as _ from 'underscore';
import { NotificationType } from '../enums';
import { NotificationOptions } from '../interfaces/options';
import { DefaultNotificationOptions } from '../const/defaultOptions/notification';

export class Notification {
	public template: KnockoutObservable<string>;
	private text: KnockoutObservable<string>;
	protected _type: KnockoutObservable<NotificationType>;
	protected type: KnockoutComputed<string>;
	public visible: KnockoutObservable<boolean>;
	private data: KnockoutObservable<{ [key: string]: any }>;
	private clickHide: () => void;
	public get isVisible(): boolean {
		return this.visible();
	}
	constructor(options?: NotificationOptions) {
		options = _.defaults(options || {}, DefaultNotificationOptions);
		this.template = ko.observable<string>();
		this.text = ko.observable<string>();
		this._type = ko.observable<NotificationType>();
		this.type = ko.pureComputed(() => NotificationType[this._type()].toLowerCase());
		this.visible = ko.observable<boolean>();
		this.data = ko.observable(options.data);

		this.clickHide = () => {
			this.hide();
		};
		this.template(options.template);
		this.text(options.text);
		this._type(options.type);
		this.visible(options.visible);
	}
	public setType = (type: NotificationType) => {
		this._type(type);
	};
	public setText = (text: string) => {
		this.text(text);
	};
	public notify = (text: string, type: NotificationType = NotificationType.Hint) => {
		this.setText(text);
		this.setType(type);
	};
	public hide = () => {
		this.visible(false);
	};
	public show = (options?: NotificationOptions) => {
		this.visible(true);
	};
	protected initNotification(options?: NotificationOptions) {
		options = _.defaults(options || {}, DefaultNotificationOptions);
		this.data(options.data);
		this.text(options.text);
		this._type(options.type);
		this.template(options.template);
		this.visible(options.visible);
	}
}
